import React, { useState, useEffect } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const IndicatorSeparator = () => null;

const SelectCityMultiple = ({
  onSelectState,
  name,
  label,
  selectedServiceState = [],
  setSelectedServiceState,
  register,
  required,
}) => {
  const [states, setStates] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await CityServices.getAllCity();
        if (Array.isArray(response.data)) {
          setStates(
            response.data.map((item) => ({
              value: item.id_city,
              label: item.name,
            }))
          );
        } else {
          console.error("API Response is not an array:", response);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  const allOption = { value: "all", label: "Select All" };

  const getSelectedOptions = () => {
    if (isAllSelected) {
      return [...states];
    }
    return selectedServiceState
      .map((value) =>
        states.find((state) =>
          typeof value === "object"
            ? state.value === value.value
            : state.value.toString() === value.toString()
        )
      )
      .filter(Boolean);
  };

  const handleStateSelect = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setIsAllSelected(true);
      setSelectedServiceState(states);
      onSelectState(states);
    } else {
      setIsAllSelected(false);
      setSelectedServiceState(selectedOptions);
      onSelectState(selectedOptions);
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
        {...register(`${name}`, {
          ...(required && {
            required: `${label} is required!`,
          }),
        })}
        isMulti
        name={name}
        options={[allOption, ...states]}
        value={getSelectedOptions()}
        onChange={handleStateSelect}
        placeholder="Select City"
        classNamePrefix="react-select"
        components={{
          IndicatorSeparator, // Removes the vertical line
        }}
      />
    </div>
  );
};

export default SelectCityMultiple;
